/**
 * Used for overriding the default behavior of Shoptet splitMenu function.
 *
 * The splitMenu function performs the following steps:
 * 1. Select the `navigation-in` element
 * 2. If the element is found, set a timer for 200 ms
 * 3. After the timer expires:
 *  a. Select all first-level menu items that do not have the `appended-category` class
 *  b. Select the element with the `menu-helper` class
 *  c. Get the computed style for the menu element
 *  d. For each menu item:
 *      i. Calculate the right offset of the item
 *      ii. Check if the item is in the `menu-helper` (special case for the item with the ID `nav-manufacturers`)
 *      iii. If the right offset is greater than the menu width minus the right padding, add the `splitted` class to the menu item and remove it from the `menu-helper`
 *      iv. If the right offset is less than or equal to the menu width minus the right padding, add the `splitted` class to the item in the `menu-helper` and remove it from the menu item
 *  e. Check if there are any unsplitted items in the `menu-helper`
 *      i. If yes, remove the `empty` class from the `menu-helper` and the `fitted` class from the menu
 *      ii. If no, add the `empty` class to the `menu-helper` and the `fitted` class to the menu
 */
const splitMenu = () => {
	const menuWrapper = document.querySelector('#navigation .navigation-in')
	if (menuWrapper) {
		setTimeout(() => {
			let menuItems = menuWrapper.querySelectorAll('.menu-level-1>li:not(.appended-category)')
			let menuHelper = document.querySelector('.menu-helper')
			let menuWrapperStyle = window.getComputedStyle(menuWrapper)
			let firstItem = menuWrapper.querySelector('.menu-level-1>li:not(.appended-category)')
			let firstItemOffsetRight = firstItem.offsetLeft + firstItem.offsetWidth
			let siteName = document.querySelector('.header-top .site-name')
			let siteNameOffsetRight = siteName ? siteName.offsetLeft + siteName.offsetWidth : 0
			menuItems.forEach((item) => {
				let offsetRight = item.offsetLeft + item.offsetWidth

				const itemInHelper =
					item.id === 'nav-manufacturers'
						? menuHelper.querySelector('#nav-manufacturers')
						: menuHelper.querySelector('.' + item.classList[0])

				if (offsetRight > menuWrapper.clientWidth) {
					if (itemInHelper) {
						itemInHelper.classList.remove('splitted')
					}
					item.classList.add('splitted')
				} else {
					if (itemInHelper) {
						itemInHelper.classList.add('splitted')
					}
					item.classList.remove('splitted')
				}
				// if (offsetRight > menuWrapper.clientWidth) {
				// 	let splitted
				// 	// if (!item.id == 'nav-manufacturers') {
				// 	splitted = menuHelper.querySelector('.' + item.classList[0])
				// 	// } else {
				// 	// 	splitted = menuHelper.querySelector('#nav-manufacturers')
				// 	// }
				// 	if (splitted) {
				// 		splitted.classList.remove('splitted')
				// 	}
				// 	item.classList.add('splitted')
				// } else {
				// 	let splitted = menuHelper.querySelector('.' + item.classList[0])
				// 	if (splitted) {
				// 		splitted.classList.add('splitted')
				// 	}
				// 	item.classList.remove('splitted')
				// }
			})
			if (menuHelper.querySelector('.menu-level-1 > li:not(.splitted):not(.appended-category)')) {
				menuHelper.classList.remove('empty')
				menuWrapper.classList.remove('fitted')
				menuHelper.classList.add('visible')
			} else {
				menuHelper.classList.add('empty')
				menuWrapper.classList.add('fitted')
				menuHelper.classList.remove('visible')
			}
		}, 200)
	}
}

/**
 * Used for overriding the default behavior of Shoptet splitMenu function.
 *
 * This function is used to split the menu with manufacturers.
 * Functionality is the same as the splitMenu function, but it also checks for the `nav-manufacturers` element.
 * The splitMenu function performs the following steps:
 * 1. Select the `navigation-in` element
 * 2. If the element is found, set a timer for 200 ms
 * 3. After the timer expires:
 *  a. Select all first-level menu items that do not have the `appended-category` class
 *  b. Select the element with the `menu-helper` class
 *  c. Get the computed style for the menu element
 *  d. For each menu item:
 *      i. Calculate the right offset of the item
 *      ii. Check if the item is in the `menu-helper` (special case for the item with the ID `nav-manufacturers`)
 *      iii. If the right offset is greater than the menu width minus the right padding, add the `splitted` class to the menu item and remove it from the `menu-helper`
 *      iv. If the right offset is less than or equal to the menu width minus the right padding, add the `splitted` class to the item in the `menu-helper` and remove it from the menu item
 *  e. Check if there are any unsplitted items in the `menu-helper`
 *      i. If yes, remove the `empty` class from the `menu-helper` and the `fitted` class from the menu
 *      ii. If no, add the `empty` class to the `menu-helper` and the `fitted` class to the menu
 */
const splitMenuWithManufacturers = () => {
	const menuWrapper = document.querySelector('#navigation .navigation-in')
	if (menuWrapper) {
		setTimeout(() => {
			let menuItems = menuWrapper.querySelectorAll('.menu-level-1>li:not(.appended-category):not(#nav-manufacturers)')
			let menuHelper = document.querySelector('.menu-helper')
			menuItems.forEach((item) => {
				let offsetRight = item.offsetLeft + item.offsetWidth
				if (offsetRight > menuWrapper.clientWidth) {
					let splitted
					if (!item.id == 'nav-manufacturers') {
						splitted = menuHelper.querySelector('.' + item.classList[0])
					} else {
						splitted = menuHelper.querySelector('#nav-manufacturers')
					}
					if (splitted) {
						splitted.classList.remove('splitted')
					}
					item.classList.add('splitted')
				} else {
					let splitted = menuHelper.querySelector('.' + item.classList[0])
					if (splitted) {
						splitted.classList.add('splitted')
					}
					item.classList.remove('splitted')
				}
			})
			if (menuHelper.querySelector('.menu-level-1 > li:not(.splitted):not(.appended-category):not(#nav-manufacturers)')) {
				menuHelper.classList.remove('empty')
				menuWrapper.classList.remove('fitted')
				menuHelper.classList.add('visible')
			} else {
				menuHelper.classList.add('empty')
				menuWrapper.classList.add('fitted')
				menuHelper.classList.remove('visible')
			}
		}, 200)
	}
	// const splitMenu = () => {
	// const menuWrapper = document.querySelector('#navigation .navigation-in')
	// if (menuWrapper) {
	// 	setTimeout(() => {
	//
	// 		let menuItems = menuWrapper.querySelectorAll('.menu-level-1>li:not(.appended-category)')
	// 		let menuHelper = document.querySelector('.menu-helper')
	// 		let menuWrapperStyle = window.getComputedStyle(menuWrapper)
	// 		menuItems.forEach((item) => {
	// 			let offsetRight = item.offsetLeft + item.offsetWidth
	// 			const itemInHelper =
	// 				item.id === 'nav-manufacturers'
	// 					? menuHelper.querySelector('#nav-manufacturers')
	// 					: menuHelper.querySelector('.' + item.classList[0])
	// 			if (offsetRight > menuWrapper.clientWidth - parseFloat(menuWrapperStyle.paddingRight)) {
	// 				if (itemInHelper) {
	// 					itemInHelper.classList.remove('splitted')
	// 				}
	// 				item.classList.add('splitted')
	// 			} else {
	// 				if (itemInHelper) {
	// 					itemInHelper.classList.add('splitted')
	// 				}
	// 				item.classList.remove('splitted')
	// 			}
	// 		})
	// 		if (menuHelper.querySelector('.menu-level-1 > li:not(.splitted):not(.appended-category)')) {
	// 			menuHelper.classList.remove('empty')
	// 			menuWrapper.classList.remove('fitted')
	// 			menuHelper.classList.add('visible')
	// 		} else {
	// 			menuHelper.classList.add('empty')
	// 			menuWrapper.classList.add('fitted')
	// 			menuHelper.classList.remove('visible')
	// 		}
	// 	}, 200)
	// }
	// }
}

/**
 * Used for overriding the default behavior of Shoptet splitMenu function.
 * @param {boolean} hasManufaturers - If true, the splitMenuWithManufacturers function will be used, otherwise the splitMenu function will be used
 */
const overrideSplitMenu = (hasManufaturers = false) => {
	shoptet.menu.splitMenu = hasManufaturers ? splitMenuWithManufacturers : splitMenu
}

/**
 * Simple debounce function. It delays the execution of the function by the specified delay.
 * @param {function} func - Function to be executed
 * @param {number} delay - Delay in milliseconds
 * @returns {function} - Debounced function
 */
const debounce = (func, delay) => {
	let debounceTimer
	return function () {
		const context = this
		const args = arguments
		clearTimeout(debounceTimer)
		debounceTimer = setTimeout(() => func.apply(context, args), delay)
	}
}

/**
 * Observes for the specified element and calls the callback function when the element is added to the DOM.
 * Use waitFor().then(() => {}) to wait for the element to be added to the DOM.
 * @param {string} selector - Selector for the element
 * @returns {Promise} - Promise that resolves when the element is added to the DOM
 */
const waitFor = async (selector) => {
	return new Promise((resolve, reject) => {
		const element = document.querySelector(selector)

		if (element) {
			resolve(element)
			return
		}

		const observer = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
				const nodes = [...mutation.addedNodes]
				for (const node of nodes) {
					if (node.matches && node.matches(selector)) {
						observer.disconnect()
						resolve(node)
						return
					}
				}
			})
		})

		observer.observe(document.body, { childList: true, subtree: true })
	})
}

/**
 * Creates an element with the specified tag, classes, and text.
 * @param {string} tag - Tag name of the element
 * @param {Array} classes - Array of classes to be added to the element
 * @param {string} text - Text content of the element
 * @returns {HTMLElement} - Created element
 */
const createElement = (tag, classes = [], text = '') => {
	const element = document.createElement(tag)
	classes.forEach((className) => element.classList.add(className))
	element.textContent = text
	return element
}

/**
 * Adds an event listener to the back-to-top button that scrolls the page to the top.
 * You should add the `div#back-to-top` element to the DOM in HTML editor.
 */
const handleBackToTopClick = () => {
	const backToTop = document.querySelector('#back-to-top')
	if (backToTop) {
		backToTop.addEventListener('click', (e) => {
			e.preventDefault()
			window.scrollTo(0, 0)
		})
	}
}

const createHeaderForTable = (table, values = []) => {
	const header = document.createElement('thead')
	const headerRow = document.createElement('tr')
	if (values.length) {
		for (let value of values) {
			const headerCell = document.createElement('th')
			headerCell.innerHTML = value
			headerRow.appendChild(headerCell)
		}
	}
	header.appendChild(headerRow)
	table.prepend(header)
}

// creates links for each product block on homepage based on config from client in editor
const createProductBlockLinks = () => {
	if (typeof hpConfig?.productBlocks !== undefined) {
		if (hpConfig.productBlocks.length) {
		}

		if (hpConfig && hpConfig.productBlocks) {
			for (let block in hpConfig.productBlocks) {
				if (hpConfig.productBlocks.hasOwnProperty(block)) {
					const productsBlock = document.querySelector(`#products-${block}`)
					if (productsBlock) {
						if (hpConfig.productBlocks[block].button) {
							// if (hpConfig.productBlocks[block].subtitle) {
							// 	const blockSubtitle = document.createElement('p')
							// 	blockSubtitle.innerHTML = hpConfig.productBlocks[block].subtitle
							// 	blockHeadingWrapper.appendChild(blockSubtitle)
							// }
							// if (hpConfig.productBlocks[block].button) {
							const buttonsWrapper = document.createElement('div')
							buttonsWrapper.classList.add('buttons-wrapper', 'buttons-center')
							const button = document.createElement('a')
							button.classList.add('btn', 'btn-secondary')
							button.innerHTML = hpConfig.productBlocks[block].button.text
							button.href = hpConfig.productBlocks[block].button.url
							buttonsWrapper.appendChild(button)
							productsBlock.appendChild(buttonsWrapper)
							// }
						}
					}
				}
			}
		}
	}
}

/** opens and closes the faq when the heading is clicked */
const handleFaq = () => {
	const faqs = document.querySelectorAll('.faq')
	if (faqs.length === 0) return
	for (let faq of faqs) {
		const heading = faq.querySelector('.faq__question')
		if (heading) {
			heading.addEventListener('click', () => {
				faq.classList.toggle('active')
			})
		}
	}

	const titles = document.querySelectorAll('.faq__sidebar .section-title')
	const faqSections = document.querySelectorAll('.faq__section')
	if (titles.length === 0 || faqSections.length === 0) return
	for (let i = 0; i < titles.length; i++) {
		titles[i].addEventListener('click', () => {
			for (let section of faqSections) {
				section.classList.remove('active')
			}
			for (let title of titles) {
				title.classList.remove('active')
			}
			if (faqSections[i]) faqSections[i].classList.add('active')
			if (titles[i]) titles[i].classList.add('active')
		})
	}
}

const handleLastVisited = () => {
	setTimeout(() => {
		const dvpnProducts = document.querySelector('.dvpnProducts') || document.querySelector('.dkLabVisitedProducts.products')
		if (dvpnProducts) {
			const lastVisitedWrapper = dvpnProducts.parentElement
			const footer = document.querySelector('footer')
			if (lastVisitedWrapper && footer) {
				footer.before(lastVisitedWrapper)
				lastVisitedWrapper.classList.add('container')
			}
			dvpnProducts.classList.remove('products-inline', 'products-top')
			dvpnProducts.classList.add('products-block')
			const slickSettings = {
				slidesToShow: 6,
				infinite: false,
				dots: true,
				arrows: true,
				responsive: [
					{
						breakpoint: 1100,
						settings: {
							slidesToShow: 4,
						},
					},
					{
						breakpoint: 767,
						settings: {
							slidesToShow: 1.7,
							arrows: false,
						},
					},
				],
			}
			$(dvpnProducts).slick(slickSettings)

			const lastVisitedHeading = document.querySelector('.dkLabVisitedProductsBox h2')

			if (lastVisitedHeading) {
				lastVisitedHeading.innerHTML = window.language === 'cs' ? 'Naposledy prohlížené' : 'Naposledy zobrazené'
			}
		}
	}, 200)
}
const createCustomContactBox = () => {
	const customContact = document.querySelector('.contact-box-placeholder')
	const customFooterContact = document.querySelector('.custom-footer__contact .contact-box')
	if (customContact && customFooterContact) {
		customContact.innerHTML = customFooterContact.innerHTML
		customContact.classList.remove('contact-box-placeholder')
		customContact.classList.add('contact-box', 'contact-box--custom')
		const mailSpan = customContact.querySelector('.mail')
		const phoneSpan = customContact.querySelector('.tel')
		const mailText = createElement('span', ['mail-text'], textKMailu ? textKMailu : '')
		const phoneText = createElement('span', ['phone-text'], textKCislu ? textKCislu : '')
		if (mailSpan) mailSpan.appendChild(mailText)
		if (phoneSpan) phoneSpan.appendChild(phoneText)
	}
}
const convertProductBlockIntoSlider = (block) => {
	const slickSettings = {
		slidesToShow: 4,
		infinite: false,
		dots: false,
		responsive: [
			{
				breakpoint: 1100,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1.3,
				},
			},
		],
	}
	$(block).slick(slickSettings)
}

const removeCommaFromMenuLevel3 = () => {
	const menuLevel3Items = document.querySelectorAll('.menu-level-3 > li')

	if (menuLevel3Items.length === 0) return

	for (let item of menuLevel3Items) {
		item.innerHTML = item.innerHTML.replace(',', '')
	}
}

const handleContactForm = (aboutDiv = false) => {
	const divAbout = document.querySelector("div[itemprop='about']") || aboutDiv
	const contactHeader = document.querySelector('article header h1')
	divAbout.classList.add('contact-form-banner')
	const contactFormWrapper = createElement('div', ['contact-form-wrapper'])
	const contactImageWrapper = createElement('div', ['contact-image-wrapper'])
	const contactImage = createElement('img', ['contact-image'])
	contactImage.src = '/user/documents/upload/miranda/contact_form.jpg'
	contactImage.alt = 'Obrázok psíka' // jazyk
	contactImageWrapper.appendChild(contactImage)

	contactFormWrapper.innerHTML = divAbout.innerHTML
	divAbout.innerHTML = ''
	divAbout.appendChild(contactFormWrapper)
	divAbout.appendChild(contactImageWrapper)
	if (contactHeader) contactFormWrapper.prepend(contactHeader)

	//add phone to form and on submit to textarea
	const formContact = document.querySelector('#formContact')
	if (!formContact) return

	const submitButton = formContact.querySelector("input[type='submit']")
	if (submitButton) {
		submitButton.classList.add('btn-paw')
		submitButton.classList.remove('btn-primary')
	}
	const emailInput = formContact.querySelector('#email')
	const fullNameInput = formContact.querySelector('#fullName')
	const messageTextarea = formContact.querySelector("textarea[name='message']")

	const telBlock = `
        <div class="form-group form-group--tel">
            <label for="tel"><span class="required-asterisk">Telefón</span></label>
            <input type="text" value="" name="tel" id="tel" class="form-control" required="" placeholder="+421 *** *** ***">
        </div>
        `
	if (fullNameInput) {
		if (dataLayer[0].shoptet.language == 'sk') fullNameInput.placeholder = 'Jakub Varga'
		const fullNameBlock = fullNameInput.closest('.form-group')
		if (fullNameBlock) fullNameBlock.classList.add('form-group--name')
	}
	if (emailInput) {
		if (dataLayer[0].shoptet.language == 'sk') emailInput.placeholder = 'vaš@email.sk'
		const emailBlock = emailInput.closest('.form-group')
		if (emailBlock) {
			emailBlock.classList.add('form-group--mail')
			emailBlock.insertAdjacentHTML('afterend', telBlock)
		}
	}
	if (messageTextarea) {
		if (dataLayer[0].shoptet.language == 'sk') messageTextarea.placeholder = 'Text'
		const messageBlock = messageTextarea.closest('.form-group')
		const messageLabel = messageTextarea.previousElementSibling.querySelector('span')
		if (messageLabel) messageLabel.textContent = 'Vaša správa'
		if (messageBlock) messageBlock.classList.add('form-group--message')
	}

	const submitForm = document.querySelector('#formContact')
	// const submitInput = submitForm.querySelector("input[type='submit']")

	submitForm.addEventListener('submit', (e) => {
		e.preventDefault()

		let textarea = submitForm.querySelector('fieldset textarea')
		if (textarea) {
			textarea.value += '\nTelefón: ' + document.querySelector('#tel').value + '\n'
		}
		submitForm.submit()
		// const messageValue = messageTextarea.value
		// let allInputsMessages = `${messageValue} | `
		// const inputTel = submitForm.querySelector("input[name='tel']")
		// // if (inputTel) {
		// const telValue = inputTel.value
		// const telMessage = `Tel. číslo: ${telValue} | `
		// allInputsMessages += telMessage
		// }

		// let formInputs = formContact.querySelectorAll('input.form-control')
		// if (formInputs.length) {
		// 	formInputs.forEach((input) => {
		// 		// if (input.name != 'tel') {
		// 			let inputValue = input.value
		// 			let inputLabel = input.closest('.form-group').querySelector('label span').textContent
		// 			let inputMessage = `${inputLabel}: ${inputValue} | `
		// 			// let inputMessage = `${inpitLabel}: ${inputValue} \n `
		// 			allInputsMessages += inputMessage
		// 		// }
		// 	})
		// }
		// let telCodeValue = contactForm.querySelector('.tel-input__button').textContent
		// let telCodeBody = contactForm.querySelector('.tel-input__body input').value
		// let telMessage = `Tel. číslo: ${telCodeValue} ${telCodeBody} \n `
		// allInputsMessages += telMessage

		// messageTextarea.value = allInputsMessages
	})

	if (dataLayer[0].shoptet.pageType === 'homepage') {
		const homepageHeading = createElement('h2', [], 'Kontaktný formulár')
		contactFormWrapper.prepend(homepageHeading)
	}
}

export {
	overrideSplitMenu,
	debounce,
	waitFor,
	createElement,
	handleBackToTopClick,
	createProductBlockLinks,
	handleLastVisited,
	createHeaderForTable,
	handleFaq,
	createCustomContactBox,
	convertProductBlockIntoSlider,
	removeCommaFromMenuLevel3,
	handleContactForm,
}
